// Table unique code → libellé humain (§18 récap 23/09). Toujours passer par ici avant d'afficher un poste / rôle.
export const POSTE_LABELS = {
  owner: 'Gérant', manager: 'Manager', controleur_gestion: 'Contrôleur de gestion', controleur: 'Contrôleur de gestion',
  chef_cuisine: 'Chef de cuisine', chef: 'Chef de cuisine', second_cuisine: 'Second de cuisine', second: 'Second de cuisine', cuisinier: 'Cuisinier', commis: 'Commis',
  aide_cuisine: 'Aide de cuisine', plongeur: 'Plongeur', plonge: 'Plongeur', patissier: 'Pâtissier', pâtissier: 'Pâtissier', pizzaiolo: 'Pizzaiolo',
  chef_de_rang: 'Chef de rang', serveur: 'Serveur', serveuse: 'Serveuse', runner: 'Runner', runner_salle: 'Runner salle', hote: 'Hôte d’accueil', hotesse: 'Hôtesse d’accueil', accueil: 'Accueil',
  barman: 'Barman', barmaid: 'Barmaid', barista: 'Barista', barrista: 'Barista', mixologue: 'Mixologue', sommelier: 'Sommelier',
  livreur: 'Livreur', resp_livraison: 'Responsable livraison', menage: 'Ménage & entretien', entretien: 'Entretien', maintenance: 'Maintenance', securite: 'Sécurité', caissier: 'Caissier',
  receptionniste: 'Réceptionniste', gouvernante: 'Gouvernante', femme_de_chambre: 'Femme de chambre', voiturier: 'Voiturier',
};
const FALLBACKS = new Set(['employee', 'employe', 'employé', 'user', 'staff', 'member', 'none', 'null', 'undefined', 'unknown', 'n/a', '']);
export const POSTE_MISSING = 'Poste non renseigné';

export const isPosteMissing = (code) => FALLBACKS.has(String(code ?? '').trim().toLowerCase());

/** Libellé humain d'un code de poste ; `Poste non renseigné` pour tout repli technique (employee, vide…). */
export const posteLabel = (code) => {
  if (isPosteMissing(code)) return POSTE_MISSING;
  const raw = String(code).trim();
  const key = raw.toLowerCase().replace(/[\s-]+/g, '_');
  if (POSTE_LABELS[key]) return POSTE_LABELS[key];
  if (/^[a-z0-9_]+$/.test(key) && key.includes('_')) return key.split('_').map((w, i) => (i ? w : w.charAt(0).toUpperCase() + w.slice(1))).join(' ');
  return raw.charAt(0).toUpperCase() + raw.slice(1);
};
